export function encryption(params) {
  var sm4 = require("sm-crypto").sm4;

  var key = "aebf8716625bf2787af98c20a80bc1c2";
  return sm4.encrypt(params, key);
}
export function generateRandomOpenId() {
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var openId = "";

  for (var i = 0; i < 28; i++) {
    var randomIndex = Math.floor(Math.random() * characters.length);
    openId += characters[randomIndex];
  }

  return openId;
}